import {
  OnlyIElementsStore,
  selectIElementsSlice,
} from "@/store/ielements-slice-selector";
import { curryAppSelector } from "@/store/reselect";
import {
  IElementImg360,
  isIElementImg360,
  type IElementGenericOdometryPath,
} from "@faro-lotv/ielement-types";
import { selectChildrenDepthFirst } from "@faro-lotv/project-source";
import { createSelector } from "@reduxjs/toolkit";

/**
 * @returns the list of 360s children of the input list of odometry paths
 * @param iElements The iElements slice of the store
 * @param paths The list of odometry path from which we want extract all 360s
 */
export const selectAllPanoramasFromPaths = curryAppSelector(
  createSelector(
    [
      selectIElementsSlice,
      (iElements: OnlyIElementsStore, paths: IElementGenericOdometryPath[]) =>
        paths,
    ],
    (iElements, paths): IElementImg360[] =>
      paths.flatMap((path) =>
        selectChildrenDepthFirst(path, isIElementImg360)({ iElements }),
      ),
  ),
);
